import { connect } from 'react-redux'
import { sagaActions } from '../../sagas'
import usersSelector from './usersSelector'
import {
  setMode,
  setKeyword
} from '../../redux/users'
import Users from './Users'

export default connect(
  usersSelector,
  {
    fetchUsers: sagaActions.fetchUsers,
    requestAddUserToKanBo: sagaActions.requestAddUserToKanBo,
    requestAddUsersFromFileToKanBo: sagaActions.requestAddUsersFromFileToKanBo,
    requestActivateUser: sagaActions.requestActivateUser,
    requestDeactivateUser: sagaActions.requestDeactivateUser,
    setMode,
    setKeyword,
  }
)(Users)
